import { render } from "./RecipeCard.vue?vue&type=template&id=35618831&scoped=true&ts=true"
import script from "./RecipeCard.vue?vue&type=script&lang=ts"
export * from "./RecipeCard.vue?vue&type=script&lang=ts"

import "./RecipeCard.vue?vue&type=style&index=0&id=35618831&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35618831"]])

export default __exports__